<dx-popup
  *ngIf="isShowForm && training"
  [width]="'90%'"
  [maxWidth]="620"
  [height]="'auto'"
  [showTitle]="true"
  [title]="'MY-TRAININGS.OVERVIEW.ACCEPT-INVITATION' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  class="modal"
  [classList]="'modal'"
  [visible]="showModal"
  (onHidden)="closeModal()"
  (onHiding)="onPopupHiding()"
>
  <div *dxTemplate="let data of 'content'">
    <div [hidden]="!isShowForm || (isShowForm && isFormSubmitted)">
      <dx-scroll-view
        [height]="'auto'"
        [useNative]="true"
        [showScrollbar]="'always'"
        class="questions-scroll"
      >
        <div 
          *ngIf="questions && questions.length !== 0"
          class="questions-container" 
        >
          <app-answer-training-questions-dialog
            [remainingParticipantSlots]="remainingParticipantSlots"
            [questions]="questions"
          ></app-answer-training-questions-dialog>
        </div>
      </dx-scroll-view>
      <div class="terms">
        <dx-check-box
          #checkbox
          [(value)]="isTermsAccepted"
        ></dx-check-box>

        <label class="terms-label" (click)="toggleCheckbox(checkbox)">
          {{ 'MY-INVITATION.TERMS' | translate }}
          <span class="required"> *</span>
        </label>
      </div>      
      <div class="form-cta">
        <dx-button
          [text]="'COMMON.CANCEL' | translate"
          type="default"
          (click)="closeModal()"
        ></dx-button>
        <dx-button
          [disabled]="!isTermsAccepted"
          [text]="'MY-INVITATION.SEND' | translate"
          type="normal"
          (click)="onSubmit()"
        ></dx-button>
      </div>
    </div>
    <div [hidden]="!isFormSubmitted" class="response-message">
      @if(isAddedToQueue) {
        <div class="text-center">
          {{ "MY-INVITATION.ADDED-TO-QUEUE-MESSAGE" | translate }}
        </div>
      } @else {
        <div>
          {{ "MY-INVITATION.SUBMIT-SUCCESS-MESSAGE" | translate }}
        </div>
      }
     
      <div class="response-cta">
        <dx-button
          [text]="'COMMON.CLOSE' | translate"
          type="normal"
          (click)="closeModal()"
        ></dx-button>
      </div>
    </div>
  </div>
</dx-popup>

<app-training-waiting-list-modal
  [showModal]="showTrainingWaitingListModal"
  (onSend)="onAddToQueue()"
  (onCancel)="onAddToQueueClose()"
></app-training-waiting-list-modal>
